module.exports = __webpack_public_path__ + "/static/assets/bc45b073cd2fc0c2265374bdb4e05d67.svg";